import cx from 'classnames'
import { ListBoxItem } from 'react-aria-components'

import { Icon } from '../../structure/icon/Icon'
import { selectStyles } from './selectStyles'
import type { SelectableItem } from './useSelectableItems'

type Props<T> = {
  currentItem: SelectableItem<T>
  disabled: boolean
  optionClassName?: string
}

export const RawSelectOption = <T,>({
  currentItem,
  disabled,
  optionClassName,
}: Props<T>) => (
  <ListBoxItem
    isDisabled={disabled}
    id={currentItem.key}
    textValue={
      // Component labels may have no extractable text until DOM resolution completes,
      // or indefinitely when skipOptionResolution is enabled.
      // React Aria still requires non-empty text for type-to-select.
      currentItem.textValue || currentItem.key
    }
    className={({ isFocused, isSelected, isDisabled }) =>
      cx(
        selectStyles.option({
          hasFocus: isFocused,
          isSelected,
          isDisabled,
        }),
        optionClassName,
      )
    }
  >
    {({ isSelected }) => (
      <>
        {currentItem.renderedOption}
        <Icon
          title="" // deliberately empty since the icon is decorative only
          name="Check"
          className={cx('ms-auto', isSelected ? 'opacity-100!' : 'opacity-0!')}
          color="unset"
        />
      </>
    )}
  </ListBoxItem>
)
